import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import { useI18n } from 'i18n/hooks/useI18n';
import { searchFacetsOrg } from 'modules/search/constants/searchFacetsOrg';
import { useSearchQuery } from 'modules/search/contexts/SearchContext';
import { SearchPage } from 'modules/search/pages/Search/SearchPage';

export function SearchOrgsPage() {
  const { i18n } = useI18n();

  useSetDocumentTitle(
    /* TRANSLATORS: org search page title */
    i18n('Discover Nonprofits & Social-Impact Organizations'),
  );

  const query = useSearchQuery();

  return (
    <SearchPage
      searchType="ORG"
      showSortOptions={Boolean(query)}
      searchFacets={searchFacetsOrg}
    />
  );
}
